import React, { forwardRef, useEffect, useState } from 'react';
import { Popover } from 'antd';
import '../style.scss';
import {
  IDownloadCenterObject,
  IEngineJson,
  IVersionItem,
} from '../../../model/api-modules/download-center';
import {
  DownloadEngine,
  DownloadPlatformType,
  DownloadObjectType,
} from '../../../model/api-modules/download';
import classNames from 'classnames';
import { DownloadSdkItem } from '../sdk-item';
import { IAPIGameItem } from '../../../model/api-modules';
import getFormatMessage from '../../../locales/get-format-message';
import clinentSdkIcon from '../../../../src/assets/svg/client-sdk-icon.svg';
import serverSdkIcon from '../../../../src/assets/svg/server-sdk-icon.svg';
import toolsIcon from '../../../../src/assets/svg/tools-icon.svg';
import sampleDemoIcon from '../../../../src/assets/svg/sample-demo-icon.svg';
import psIcon from '../../../../src/assets/svg/ps-icon.svg';
import xsxIcon from '../../../../src/assets/svg/xsx-icon.svg';
import switchIcon from '../../../../src/assets/svg/download-switch-icon.svg';
import windowsIcon from '../../../../src/assets/svg/windows-icon.svg';
import iosIcon from '../../../../src/assets/svg/ios-icon.svg';
import androidIcon from '../../../../src/assets/svg/android-icon.svg';
import psIconDisable from '../../../../src/assets/svg/ps-icon-disable.svg';
import xsxIconDisable from '../../../../src/assets/svg/xsx-icon-disable.svg';
import switchIconDisable from '../../../../src/assets/svg/download-switch-icon-disable.svg';
import windowsIconDisable from '../../../../src/assets/svg/windows-icon-disable.svg';
import iosIconDisable from '../../../../src/assets/svg/ios-icon-disable.svg';
import androidIconDisable from '../../../../src/assets/svg/android-icon-disable.svg';
import platformSelect from '../../../../src/assets/svg/platform-select.svg';
import downloadListEmpty from '../../../../src/assets/images/download-list-empty.png';
interface IProps {
  readonly configKey: string;
  readonly selectPlatform: DownloadPlatformType[];
  readonly setSelectPlatform: (value: DownloadPlatformType[]) => void;
  readonly objectList: IDownloadCenterObject[];
  readonly engineSelectData: any;
  readonly onEngineDataChange: (
    id: number,
    key: string,
    value: number | string,
    versionItem?: IVersionItem
  ) => void;
  readonly abledPlatform: DownloadPlatformType[];
  readonly selectSdk: number[];
  readonly setSelectSdk: (value: number[]) => void;
  readonly studioList: IAPIGameItem[];
  readonly subVersionIDsList: {
    id: number;
    subVersionTags: string[];
  }[];
  readonly setSubVersionIDsList: React.Dispatch<
    React.SetStateAction<
      {
        id: number;
        subVersionTags: string[];
      }[]
    >
  >;
}

interface IOption {
  readonly label: string;
  readonly value: string | number;
}

export const DownloadSdkConfig = forwardRef(
  (props: IProps, refFromParent: any) => {
    const [isShowEmpty, setIsShowEmpty] = useState<boolean>(false);

    useEffect(() => {
      if (props.configKey === 'Client') {
        getIsShowEmpty();
      }
    }, [props.engineSelectData, props.selectPlatform, props.objectList]);

    const clickPlatform = (value: DownloadPlatformType) => {
      if (props.abledPlatform.indexOf(value) === -1) {
        return;
      }
      const currentPlatform = Object.assign([], props.selectPlatform);
      if (currentPlatform.indexOf(value) === -1) {
        currentPlatform.push(value);
      } else {
        currentPlatform.splice(currentPlatform.indexOf(value), 1);
      }
      props.setSelectPlatform(currentPlatform);
    };

    const objectList: IDownloadCenterObject[] = [];

    let sdkIcon;
    let sdkTitle;
    switch (props.configKey) {
      case 'Client':
        sdkTitle = getFormatMessage('client_side_sdk');
        sdkIcon = clinentSdkIcon;
        props.objectList.forEach((item) => {
          if (item.Type === DownloadObjectType.Client) {
            objectList.push(item);
          }
        });
        break;
      case 'Server':
        sdkTitle = getFormatMessage('server_side_sdk');
        sdkIcon = serverSdkIcon;
        props.objectList.forEach((item) => {
          if (item.Type === DownloadObjectType.Server) {
            objectList.push(item);
          }
        });
        break;
      case 'Sample':
        sdkTitle = getFormatMessage('sample_demo');
        sdkIcon = sampleDemoIcon;
        props.objectList.forEach((item) => {
          if (item.Type === DownloadObjectType.Sample) {
            objectList.push(item);
          }
        });
        break;
      case 'Tools':
        sdkTitle = getFormatMessage('download_tools');
        sdkIcon = toolsIcon;
        props.objectList.forEach((item) => {
          if (item.Type === DownloadObjectType.Tools) {
            objectList.push(item);
          }
        });
        break;
    }

    const renderSpan = (value: DownloadPlatformType, name: string) => {
      let imgSrc;
      let imgSrcDisable;
      switch (value) {
        case DownloadPlatformType.PS4:
          imgSrc = psIcon;
          imgSrcDisable = psIconDisable;
          break;
        case DownloadPlatformType.PS5:
          imgSrc = psIcon;
          imgSrcDisable = psIconDisable;
          break;
        case DownloadPlatformType.XSX:
          imgSrc = xsxIcon;
          imgSrcDisable = xsxIconDisable;
          break;
        case DownloadPlatformType.Switch:
          imgSrc = switchIcon;
          imgSrcDisable = switchIconDisable;
          break;
        case DownloadPlatformType.Windows:
          imgSrc = windowsIcon;
          imgSrcDisable = windowsIconDisable;
          break;
        case DownloadPlatformType.Mac:
          imgSrc = iosIcon;
          imgSrcDisable = iosIconDisable;
          break;
        case DownloadPlatformType.Android:
          imgSrc = androidIcon;
          imgSrcDisable = androidIconDisable;
          break;
        case DownloadPlatformType.IOS:
          imgSrc = iosIcon;
          imgSrcDisable = iosIconDisable;
          break;
      }
      if (props.abledPlatform.indexOf(value) === -1) {
        return (
          <Popover
            overlayClassName="in-game-ant-popover-content"
            content={getFormatMessage('comingSoon')}
            trigger="hover"
            placement="topLeft"
          >
            <span
              className={classNames(
                'download-config-item',
                props.selectPlatform.indexOf(value) !== -1
                  ? 'select-platform'
                  : '',
                props.abledPlatform.indexOf(value) === -1
                  ? 'disabled-platform'
                  : ''
              )}
              onClick={() => clickPlatform(value)}
            >
              <img src={imgSrc} className="download-config-item-icon" />
              <img
                src={imgSrcDisable}
                className="download-config-item-icon-disable"
              />
              <span>{name}</span>
              <img
                src={platformSelect}
                className="download-platform-select-icon"
              />
            </span>
          </Popover>
        );
      }
      return (
        <span
          className={classNames(
            'download-config-item',
            props.selectPlatform.indexOf(value) !== -1 ? 'select-platform' : '',
            props.abledPlatform.indexOf(value) === -1 ? 'disabled-platform' : ''
          )}
          onClick={() => clickPlatform(value)}
        >
          <img src={imgSrc} className="download-config-item-icon" />
          <img
            src={imgSrcDisable}
            className="download-config-item-icon-disable"
          />
          <span>{name}</span>
          <img src={platformSelect} className="download-platform-select-icon" />
        </span>
      );
    };

    const getIsShowEmpty = () => {
      let isShow = true;
      const nonsupportList = [];
      const newSelectSdk = Object.assign([], props.selectSdk);
      objectList &&
        props.engineSelectData.length !== 0 &&
        objectList.forEach((objectItem) => {
          if (props.selectPlatform.length !== 0) {
            const engineItem = props.engineSelectData.find(
              (item: any) => item.id === objectItem.id
            );
            const engineJsonItem = engineItem.versionItem?.EngineJson.find(
              (item: any) => item.type === engineItem.engine
            );
            let isPush = false;
            props.selectPlatform.forEach((item) => {
              if (engineJsonItem?.platform) {
                if (engineJsonItem.platform.indexOf(item) === -1) {
                  isPush = true;
                  if (newSelectSdk.indexOf(objectItem.id) !== -1) {
                    newSelectSdk.splice(newSelectSdk.indexOf(objectItem.id), 1);
                  }
                }
              }
            });
            // 添加选择平台不支持的sdk
            if (isPush) {
              nonsupportList.push(engineItem);
            }
          } else {
            if (newSelectSdk.indexOf(objectItem.id) !== -1) {
              newSelectSdk.splice(newSelectSdk.indexOf(objectItem.id), 1);
            }
          }
        });
      props.setSelectSdk(newSelectSdk);
      // 选中平台并且选中平台后有能支持的sdk则不显示空列表
      if (
        props.selectPlatform.length !== 0 &&
        nonsupportList.length !== objectList.length
      ) {
        isShow = false;
      }
      setIsShowEmpty(isShow);
    };

    return (
      <div className="download-config">
        <div>
          <img src={sdkIcon} className="download-config-icon" />
          <span className="download-config-title">{sdkTitle}</span>
        </div>
        {props.configKey === 'Client' && (
          <div className="download-config-box">
            <div
              className="download-config-single-end"
              style={{ marginRight: '48px' }}
            >
              <div className="download-config-single-icon">
                {getFormatMessage('host_platform')}
              </div>
              <div className="download-config-single-item-box">
                {renderSpan(DownloadPlatformType.PS4, 'PS4')}
                {renderSpan(DownloadPlatformType.PS5, 'PS5')}
                {renderSpan(DownloadPlatformType.XSX, 'XSX')}
                {renderSpan(DownloadPlatformType.Switch, 'Switch')}
              </div>
            </div>
            <div className="download-config-single-end">
              <div className="download-config-single-icon">
                {getFormatMessage('computer_platform')}
              </div>
              <div className="download-config-single-item-box">
                {renderSpan(DownloadPlatformType.Windows, 'Windows')}
                {renderSpan(DownloadPlatformType.Mac, 'MacOS')}
              </div>
            </div>
            <div className="download-config-single-end" style={{ order: 99 }}>
              <div className="download-config-single-icon">
                {getFormatMessage('mobile_platform')}
              </div>
              <div className="download-config-single-item-box">
                {renderSpan(DownloadPlatformType.Android, 'Android')}
                {renderSpan(DownloadPlatformType.IOS, 'iOS')}
              </div>
            </div>
          </div>
        )}
        {props.configKey === 'Client' && isShowEmpty && (
          <div className="client-empty-sdk">
            <img src={downloadListEmpty} />
            <div>
              {props.selectPlatform.length === 0
                ? getFormatMessage('client_platform_unselected')
                : getFormatMessage('client_platform_nonsupport')}
            </div>
          </div>
        )}
        <div>
          {objectList &&
            props.engineSelectData.length !== 0 &&
            objectList.map((objectItem) => {
              const engineData = props.engineSelectData.find(
                (item: any) => item.id === objectItem.id
              );
              const rawEngineJson: IEngineJson[] =
                engineData?.versionItem?.EngineJson || [];
              const engineJson = rawEngineJson.filter((engineInfo) => {
                const { selectPlatform = [] } = props;
                const isMatchPlat = selectPlatform.every((plat) =>
                  engineInfo.platform.includes(plat)
                );

                return isMatchPlat;
              });
              const engineOptions: IOption[] = [];
              const versionOptions: IOption[] = [];
              const pssdkVersionOptions: IOption[] = [];
              const gdkVersionOptions: IOption[] = [];
              engineJson.forEach((item: any) => {
                let itemLabel = '';
                if (item.type === DownloadEngine.CPP) {
                  itemLabel = getFormatMessage('cpp');
                } else if (item.type === DownloadEngine.UEPlugin) {
                  itemLabel = getFormatMessage('ue_plugin');
                } else if (item.type === DownloadEngine.UnityPlugin) {
                  itemLabel = getFormatMessage('unity_plugin');
                }
                engineOptions.push({
                  label: itemLabel,
                  value: item.type,
                });
                if (item.type === engineData?.engine) {
                  item.version?.forEach((versionItem: any) => {
                    versionOptions.push({
                      label: versionItem,
                      value: versionItem,
                    });
                  });
                  item.pssdkVersion?.forEach((versionItem: any) => {
                    pssdkVersionOptions.push({
                      label: versionItem,
                      value: versionItem,
                    });
                  });
                  item.gdkVersion?.forEach((versionItem: any) => {
                    gdkVersionOptions.push({
                      label: versionItem,
                      value: versionItem,
                    });
                  });
                }
              });

              return (
                <DownloadSdkItem
                  objectItem={objectItem}
                  engineOptions={engineOptions}
                  engineData={engineData}
                  versionOptions={versionOptions}
                  pssdkVersionOptions={pssdkVersionOptions}
                  gdkVersionOptions={gdkVersionOptions}
                  onEngineDataChange={props.onEngineDataChange}
                  selectSdk={props.selectSdk}
                  setSelectSdk={props.setSelectSdk}
                  studioList={props.studioList}
                  engineSelectData={props.engineSelectData}
                  selectPlatform={props.selectPlatform}
                  subVersionIDsList={props.subVersionIDsList}
                  setSubVersionIDsList={props.setSubVersionIDsList}
                  ref={(el) => {
                    if (el && refFromParent) {
                      refFromParent.current[objectItem.id] = el;
                    }
                  }}
                />
              );
            })}
        </div>
      </div>
    );
  }
);
